<!-- <div class="position-relative"> -->
<nav class="navbar navbar-expand-lg bg-snow-white layout  rounded-12 sticky-top">
    <div class="container-fluid p-0">
        <div (click)="showWorkSpaces()">
            <div class="image-wrapper rounded-12 d-flex justify-content-center align-items-center  border border-cool-gray rounded-8 me-3"
                *ngIf="!workSpaceService.activeWorkspace()?.logo_url">
                <img src="assets/images/default-logo.svg" alt="deafult-image" width="22">
            </div>
            <img [src]="workSpaceService.activeWorkspace()?.logo_url" class="profile-image rounded-8 me-3" width="35"
                height="35" alt="" *ngIf="workSpaceService.activeWorkspace()?.logo_url">
        </div>
        <a class="navbar-brand ps-3" [routerLink]="['/']"> <img src="assets/images/trace-logo.svg" alt="trace-logo"></a>
        <button class="navbar-toggler mb-3" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link" aria-current="page">My Task</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="redirectTo('projects')"
                        [class.active]="active() === 'projects'">Projects</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link">Filters</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link">Dashboards</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="redirectTo('members')"
                        [class.active]="active() === 'members'">Members</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="redirectTo('clients')"
                        [class.active]="active() === 'clients'">Clients</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link">Teams</a>
                </li>
                <li class="nav-item" >
                    <a class="nav-link" (click)="redirectTo('apps')" [class.active]="active() === 'apps'">Apps</a>
                </li>
            </ul>
        </div>
        <div class="d-flex nav-right">
            <div class="flex-grow-1">
                <div class="position-relative">
                    <img src="assets/icons/search.svg" alt="profile-image" class="search-icon">
                </div>
                <input type="text" class="form-control shadow-none border-secondary rounded-12" placeholder="Search"
                    aria-label="Username" aria-describedby="basic-addon1">
            </div>
            <div class="rounded-5">
                <img src="assets/icons/notification.svg" alt="profile-image">
            </div>
            <!-- TODO: Uncomment this after release dev to make settings icon visible (click)="redirectTo('settings') -->
            <div class="rounded-5 settings-icon d-inline-flex align-items-center justify-content-center" role="button"
                title="Settings" [class.active]="active() === 'settings'" (click)="redirectTo('settings')">
                <img [src]="active() === 'settings' ? 'assets/icons/setting-active.svg' : 'assets/icons/setting.svg'"
                    alt="settings">
            </div>
            <div class="rounded-5">
                <div class="dropdown">
                    <img src="assets/images/default-user.svg"  *ngIf="!userService.userDetail()?.photo_url"
                        class="profile-image " alt="profile-image" width="35" height="35" data-bs-toggle="dropdown"
                        aria-expanded="false">
                    <img [src]="userService.userDetail()?.photo_url"  *ngIf="userService.userDetail()?.photo_url"
                        class="profile-image rounded-5" alt="profile-image" width="35" height="35"
                        data-bs-toggle="dropdown" aria-expanded="false">
                    <ul class="dropdown-menu rounded-12" data-bs-auto-close="outside">
                        <li>
                            <a class="dropdown-item">
                                <div class="d-flex">
                                    <img src="assets/images/default-user.svg"
                                        *ngIf="!userService.userDetail()?.photo_url" width="40" height="40"
                                        class="profile-image" alt="profile-image">
                                    <img [src]="userService.userDetail()?.photo_url"
                                        *ngIf="userService.userDetail()?.photo_url" width="40" height="40"
                                        class="profile-image rounded-5" alt="profile-image">
                                    <div class="ms-2">
                                        <h5 class="mb-0 text-secondary-grey  fs-14">{{fullName()}}</h5>
                                        <span
                                            class="text-secondary-grey  small">{{userService.userDetail()?.email}}</span>
                                    </div>
                                </div>
                            </a>

                        </li>
                        <hr class="my-1 border border-cool-grey">
                        <li class="mb-2" [routerLink]="['/profile']">
                            <a class="dropdown-item">
                                <img src="assets/icons/profile.svg" width="20" height="20" alt="profile">
                                <span class="text-secondary-grey ms-3 fs-14">My Profile</span>
                            </a>
                        </li>
                        <li class="mb-2">
                            <a class="dropdown-item" >
                                <img src="assets/icons/change-password.svg" width="22" height="22" alt="lock-icon">
                                <span class="text-secondary-grey ms-3 fs-14">Change Password</span>
                            </a>
                        </li>
                        <li class="mb-2" >
                            <div class="dropdown">
                                <a class="dropdown-item" (click)="showThemes($event)">
                                    <div class="d-flex  justify-content-between align-items-center ">
                                        <div>
                                            <img src="assets/icons/fa-brush.svg" width="20" height="20"
                                                alt="brush-icon">
                                            <span class="text-secondary-grey ms-3 fs-14">Theme</span>
                                        </div>
                                        <svg width="10" height="10" viewBox="0 0 10 6" fill="none"
                                            xmlns="http://www.w3.org/2000/svg" [class.rotate]="showThemesOptions()">
                                            <path
                                                d="M9 1L5.70707 4.67453C5.31818 5.10849 4.68182 5.10849 4.29293 4.67453L1 1"
                                                stroke="#565B62" stroke-width="1.5" stroke-miterlimit="10"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </a>
                                <ul class="custom-menu" *ngIf="showThemesOptions()">
                                    <li class="mb-2" [ngClass]="{'active' :isChangeTheme() ==='light' }"
                                        (click)="changeTheme('light')"><a class="dropdown-item  text-secondary-grey">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M9 2.6V1M9 15.4V17M4.53137 4.53137L3.4 3.4M13.5824 13.5824L14.7138 14.7138M2.6 9H1M15.4 9H17M13.5828 4.53137L14.7142 3.4M4.53176 13.5824L3.40039 14.7138M9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13Z"
                                                    [attr.stroke]="isChangeTheme() ==='light' ? '#4E3162' : '#565B62'"
                                                    stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            <span class="ms-2 fs-14"
                                                [ngClass]="{'text-brand-purple' : isChangeTheme() ==='light'}">
                                                Light</span></a></li>
                                    <li class="mb-2" [ngClass]="{'active' :isChangeTheme() ==='dark' }"
                                        (click)="changeTheme('dark')"><a class="dropdown-item  text-secondary-grey">
                                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M6.10954 3.72627C6.10954 7.95915 9.54096 11.3906 13.7738 11.3906C14.5482 11.3906 15.2957 11.2761 16.0002 11.0625C15.0464 14.2096 12.1229 16.5 8.66431 16.5C4.43143 16.5 1 13.0688 1 8.83593C1 5.37736 3.29084 2.45385 6.43791 1.5C6.22436 2.20458 6.10954 2.95196 6.10954 3.72627Z"
                                                    [attr.stroke]="isChangeTheme() ==='dark' ? '#4E3162' : '#565B62'"
                                                    stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            <span class="ms-2 fs-14"
                                                [ngClass]="{'text-brand-purple' : isChangeTheme() ==='dark'}"> Dark
                                            </span> </a></li>
                                </ul>
                            </div>

                        </li>
                        <li class="mb-2">
                            <a class="dropdown-item">
                                <img src="assets/icons/fa-question-mark.svg" width="20" height="20"
                                    alt="question-mark-icon">
                                <span class="text-secondary-grey ms-3 fs-14">Help</span>
                            </a>
                        </li>
                        <li class="mb-2">
                            <a class="dropdown-item">
                                <img src="assets/icons/fa-people.svg" width="20" height="20" alt="brush-icon">
                                <span class="text-secondary-grey ms-3 fs-14">Switch Account</span>
                            </a>
                        </li>
                        <li class="mb-2">
                            <a class="dropdown-item">
                                <img src="assets/icons/fa-user.svg" width="20" height="20" alt="brush-icon">
                                <span class="text-secondary-grey ms-3 fs-14">Deactivate Account</span>
                            </a>
                        </li>
                        <li class="mb-2" (click)="logOut()">
                            <a class="dropdown-item">
                                <img src="assets/icons/log-out.svg" alt="log-out" width="20" height="20">
                                <span class="text-brand-warning ms-3 fs-14">Log Out </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</nav>
<app-list-item-selector *ngIf="isShowWorkSpaces()" [wrapperClass]="'isShowWorkSpaces'"
    [defaultImage]="'assets/images/default-logo.svg'" [items]="workSpaceService._workSpaceList()"
    [isShowEditIcon]="true" (redirectTo)="redirectToWorkSpace($event)" [loader]="loader()" appClickOutside
    (editWorkspace)="editWorkspace($event)" (appClickOutside)="isShowWorkSpaces.set(false)">
</app-list-item-selector>
<!-- </div> -->